import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4 p-0">
      {/* Footer Top */}
      <div className="footer-top aos p-0" data-aos="fade-up">
        <div className="container px-0">
          <div className="row px-0 ">
            {/* Footer Contact */}
       <div className="col-lg-3 px-0">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
        Discover hassle-free travel with Sai Shirdi Cabs, your trusted partner for Shirdi sightseeing, temple visits, outstation trips, airport transfers and popular pilgrimage destinations across Maharashtra.


      </p>

      {/* Phone */}
      <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#D40000" }}></i>
        <a href="tel:+917776814559" style={{ color: "#fff", textDecoration: "none" }}>+91 7776814559</a>
      </p>
   
     <p className="d-flex align-items-center mb-2">
        <i className="fas fa-phone-alt me-2" style={{ color: "#D40000" }}></i>
        <a href="tel:+919579032227" style={{ color: "#fff", textDecoration: "none" }}>+91 9579032227</a>
      </p>
   
 
   

      {/* Address */}
      <p className="d-fle align-items-start text-white">
        
        <h6><i className="fas fa-map-marker-alt me-2 mt-1 " style={{ color: "#D40000" }}></i>Sai Shirdi Cabs</h6>
      Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                 Shirdi,Tel - Rahata,Dist Ahilyanagar,
                 Maharashtra, India - 423109



      </p>
    </div>
<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2859.999117527117!2d74.4785!3d19.769361099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDQ2JzA5LjciTiA3NMKwMjgnNDIuNiJF!5e1!3m2!1sen!2sin!4v1788100150998!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

     


    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/saishirdicab/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61594314687536" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/saishirdicab" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/saishirdicab/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
    
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Nagarsol-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Nagarsol to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-Cab-Service"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Cab Service</Link></li>

<li><Link to="/Shirdi-to-Shani-Shingnapur-Cab"><i className="fa-solid fa-taxi darkcolor"></i> Shirdi to Shani Shingnapur Cab</Link></li>

<li><Link to="/Shirdi-to-Grishneshwar-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Grishneshwar Cab</Link></li>

<li><Link to="/Shirdi-to-Manmad-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Manmad Cab</Link></li>

<li><Link to="/Shirdi-to-Lonavala-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Lonavala Cab</Link></li>

<li><Link to="/Shirdi-to-Mahabaleshwar-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Mahabaleshwar Cab</Link></li>

<li><Link to="/Shirdi-to-Ashtavinayak-Darshan-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Ashtavinayak Darshan Package</Link></li>

<li><Link to="/Shirdi-to-Saptashrungi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Saptashrungi Cab</Link></li>

<li><Link to="/Shirdi-Tour-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Tour Package</Link></li>

<li><Link to="/Best-Taxi-Service-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Best Taxi Service in Shirdi</Link></li>

<li><Link to="/Shirdi-Airport-Cab-Service"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Airport Cab Service</Link></li>

<li><Link to="/Online-Cab-Booking-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Online Cab Booking Shirdi</Link></li>

<li><Link to="/Best-Travel-Agency-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Best Travel Agency in Shirdi</Link></li>

<li><Link to="/Shirdi-to-Mumbai-Airport-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Mumbai Airport Cab</Link></li>

<li><Link to="/Kopargaon-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Kopargaon to Shirdi Cab</Link></li>

<li><Link to="/Innova-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Innova on Rent in Shirdi</Link></li>

<li><Link to="/Shirdi-Sightseeing-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Sightseeing Cab</Link></li>

<li><Link to="/Shirdi-Darshan-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Darshan Taxi</Link></li>

<li><Link to="/Bus-on-Hire-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Bus on Hire in Shirdi</Link></li>

<li><Link to="/Best-Sedan-Cab-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Best Sedan Cab in Shirdi</Link></li>

<li><Link to="/Ertiga-Car-Hire-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Ertiga Car Hire in Shirdi</Link></li>

<li><Link to="/Innova-Crysta-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Innova Crysta on Rent in Shirdi</Link></li>

<li><Link to="/Mini-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Mini Bus on Rent in Shirdi</Link></li>

<li><Link to="/Tempo-Traveller-Hire-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Tempo Traveller Hire in Shirdi</Link></li>

<li><Link to="/Shirdi-to-Hyderabad-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Hyderabad Cab</Link></li>

<li><Link to="/Shirdi-to-Ujjain-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Ujjain Cab</Link></li>

<li><Link to="/Shirdi-to-Saputara-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Saputara Cab</Link></li>

<li><Link to="/Shirdi-to-Aurangabad-Airport-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Aurangabad Airport Cab</Link></li>

<li><Link to="/32-35-40-45-50-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 32, 35, 40, 45, 50 Seater Bus on Rent in Shirdi</Link></li>

<li><Link to="/Shirdi-to-Pandharpur-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Pandharpur Cab</Link></li>

<li><Link to="/Ozar-Airport-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Ozar Airport to Shirdi Cab</Link></li>

<li><Link to="/Nashik-Railway-Station-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Nashik Railway Station to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-to-Bhandardara-Cab-On-Rent"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Bhandardara Cab On Rent</Link></li>

<li><Link to="/Nashik-Airport-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Nashik Airport to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-to-Igatpuri-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Igatpuri Cab</Link></li>

<li><Link to="/Shirdi-to-Goa-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Goa Cab</Link></li>

<li><Link to="/Corporate-Cab-Service-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Corporate Cab Service in Shirdi</Link></li>

<li><Link to="/Shirdi-to-Mumbai-Darshan-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Mumbai Darshan Taxi</Link></li>

<li><Link to="/Shirdi-to-Nagpur-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Nagpur Taxi</Link></li>

<li><Link to="/Best-Cab-Service-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Best Cab Service in Shirdi</Link></li>


                   
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>
<li><Link to="/Outstation-Cab-Service-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Outstation Cab Service in Shirdi</Link></li>

<li><Link to="/Manmad-to-Shirdi-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Manmad to Shirdi Taxi</Link></li>

<li><Link to="/Shirdi-to-Trimbakeshwar-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Trimbakeshwar Cab</Link></li>

<li><Link to="/Shirdi-to-Bhimashankar-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Bhimashankar Cab</Link></li>


<li><Link to="/Shirdi-to-Nasik-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Nasik Cabs</Link></li>

<li><Link to="/Nashik-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Nashik to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-to-Aurangabad-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Aurangabad Taxi</Link></li>

<li><Link to="/Shirdi-to-Shani-Shingnapur-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Shani Shingnapur Taxi</Link></li>

<li><Link to="/Shirdi-to-Manmad-Taxi-Fare"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Manmad Taxi Fare</Link></li>

<li><Link to="/Solapur-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Solapur to Shirdi Cab</Link></li>

<li><Link to="/Daund-to-Shirdi-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Daund to Shirdi Cabs</Link></li>

<li><Link to="/Shirdi-to-Goa-Cab-Service"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Goa Cab Service</Link></li>

<li><Link to="/Shirdi-to-Pune-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Pune Cabs</Link></li>

<li><Link to="/Shirdi-to-Mumbai-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Mumbai Cab</Link></li>

<li><Link to="/Mumbai-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Mumbai to Shirdi Cab</Link></li>

<li><Link to="/Mumbai-Airport-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Mumbai Airport to Shirdi Cab</Link></li>

<li><Link to="/Pune-Airport-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Pune Airport to Shirdi Cab</Link></li>

<li><Link to="/Pune-to-Shirdi-Cab-Booking"><i className="fa-solid fa-car-rear darkcolor"></i> Pune to Shirdi Cab Booking</Link></li>

<li><Link to="/Shirdi-Airport-to-Nashik-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Airport to Nashik Cab</Link></li>

<li><Link to="/Shirdi-to-Ajanta-Ellora-Caves-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Ajanta Ellora Caves Package</Link></li>

<li><Link to="/Shirdi-to-5-Jyotirlinga-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to 5 Jyotirlinga Package</Link></li>

<li><Link to="/Shirdi-Airport-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Airport Cabs</Link></li>

<li><Link to="/Mumbai-to-Shirdi-Tour-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Mumbai to Shirdi Tour Package</Link></li>

<li><Link to="/Shirdi-Car-Rentals"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Car Rentals</Link></li>

<li><Link to="/Shirdi-to-Indore-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Indore Cabs</Link></li>

<li><Link to="/Wedding-Car-Rental-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Wedding Car Rental Shirdi</Link></li>

<li><Link to="/Nasik-Airport-to-Shirdi-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Nasik Airport to Shirdi Taxi</Link></li>

<li><Link to="/Kalyan-to-Shirdi-Car-Rental"><i className="fa-solid fa-car-rear darkcolor"></i> Kalyan to Shirdi Car Rental</Link></li>

<li><Link to="/Shirdi-to-Verul-Car-Rentals"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Verul Car Rentals</Link></li>

<li><Link to="/Shirdi-to-Konkan-Darshan-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Konkan Darshan Cab</Link></li>

<li><Link to="/Bus-Hire-for-Wedding-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Bus Hire For Wedding in Shirdi</Link></li>

<li><Link to="/Cab-Booking-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Cab Booking in Shirdi</Link></li>

<li><Link to="/Shirdi-Taxi-Booking-Online"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Taxi Booking Online</Link></li>

<li><Link to="/Shirdi-Cab-Packages"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Cab Packages</Link></li>

<li><Link to="/Shirdi-to-Outstation-Cabs-Booking"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Outstation Cabs Booking</Link></li>

<li><Link to="/Travel-Agents-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Travel Agents in Shirdi</Link></li>

<li><Link to="/Corporate-Cab-Services-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Corporate Cab Services in Shirdi</Link></li>

<li><Link to="/Cabs-for-Events-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Cabs for Events in Shirdi</Link></li>

<li><Link to="/Cab-Service-in-Shirdi-MIDC"><i className="fa-solid fa-car-rear darkcolor"></i> Cab Service in Shirdi MIDC</Link></li>

<li><Link to="/Monthly-Cab-Service-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Monthly Cab Service Shirdi</Link></li>

<li><Link to="/Sainagar-Shirdi-to-Shirdi-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Sainagar Shirdi to Shirdi Cabs</Link></li>
              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>




<li><Link to="/Nashik-Road-Station-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Nashik Road Station to Shirdi Cab</Link></li>

<li><Link to="/Swift-Dzire-On-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Swift Dzire On Rent in Shirdi</Link></li>

<li><Link to="/Innova-Crysta-Cab-on-Rent-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Innova Crysta Cab on Rent Shirdi</Link></li>

<li><Link to="/Ertiga-On-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Ertiga On Rent in Shirdi</Link></li>

<li><Link to="/Innova-Cab-Booking-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Innova Cab Booking in Shirdi</Link></li>

<li><Link to="/Etios-Cab-Service-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Etios Cab Service in Shirdi</Link></li>

<li><Link to="/Kia-Carens-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Kia Carens on Rent in Shirdi</Link></li>

<li><Link to="/Tempo-Traveller-14-Seater-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Tempo Traveller 14 Seater Rent in Shirdi</Link></li>

<li><Link to="/Tempo-Traveller-17-Seater-on-Rent-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Tempo Traveller 17 Seater on Rent Shirdi</Link></li>


<li><Link to="/25-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 25 Seater Bus on Rent in Shirdi</Link></li>

<li><Link to="/32-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 32 Seater Bus on Rent in Shirdi</Link></li>

<li><Link to="/35-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 35 Seater Bus on Rent in Shirdi</Link></li>

<li><Link to="/45-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 45 Seater Bus on Rent in Shirdi</Link></li>

<li><Link to="/50-Seater-Bus-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 50 Seater Bus on Rent in Shirdi</Link></li>


<li><Link to="/Taxi-Booking-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Taxi Booking in Shirdi</Link></li>

<li><Link to="/Navi-Mumbai-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Navi Mumbai to Shirdi Cab</Link></li>

<li><Link to="/Thane-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Thane to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-to-Pune-Airport-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Pune Airport Cab</Link></li>

<li><Link to="/Shirdi-to-Mumbai-Airport-Taxi"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Mumbai Airport Taxi</Link></li>

<li><Link to="/Shirdi-Local-Sightseeing-Cabs"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Local Sightseeing Cabs</Link></li>

<li><Link to="/One-Way-Cab-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> One Way Cab Shirdi</Link></li>

<li><Link to="/Shirdi-to-Shegaon-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Shegaon Cab</Link></li>

<li><Link to="/Aurangabad-Airport-to-Shirdi-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Aurangabad Airport to Shirdi Cab</Link></li>

<li><Link to="/Shirdi-Round-Trip-Cab-Booking"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi Round Trip Cab Booking</Link></li>

<li><Link to="/Shirdi-to-Ooty-Mysore-Cab-Package"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Ooty Mysore Cab Package</Link></li>

<li><Link to="/Shirdi-to-Gujarat-Cab"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to Gujarat Cab</Link></li>

<li><Link to="/Shirdi-to-All-India-Explorer-Cab-Service"><i className="fa-solid fa-car-rear darkcolor"></i> Shirdi to All India Explorer Cab Service</Link></li>

<li><Link to="/Urbania-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania on Rent in Shirdi</Link></li>

<li><Link to="/Urbania-on-Rent-at-Shirdi-Airport"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania on Rent at Shirdi Airport</Link></li>

<li><Link to="/Outstation-Urbania-from-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Outstation Urbania from Shirdi</Link></li>

<li><Link to="/17-Seater-Urbania-on-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 17 Seater Urbania on Rent in Shirdi</Link></li>

<li><Link to="/14-Seater-Urbania-On-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 14 Seater Urbania On Rent in Shirdi</Link></li>

<li><Link to="/Luxury-Urbania-On-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Luxury Urbania On Rent in Shirdi</Link></li>

<li><Link to="/Urbania-On-Rent-in-Ahilyanagar"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania On Rent in Ahilyanagar</Link></li>

<li><Link to="/Urbania-on-Rent-in-Manmad"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania on Rent in Manmad</Link></li>

<li><Link to="/Urbania-On-Rent-in-Nashik"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania On Rent in Nashik</Link></li>

<li><Link to="/Urbania-On-Rent-in-Shrirampur"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania On Rent in Shrirampur</Link></li>

<li><Link to="/Urbania-Hire-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> Urbania Hire in Shirdi</Link></li>

<li><Link to="/17-Seater-Tempo-Traveller-On-Rent-in-Shirdi"><i className="fa-solid fa-car-rear darkcolor"></i> 17 Seater Tempo Traveller On Rent in Shirdi</Link></li>

 </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Sai Shirdi Cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


